import React from 'react';
import './Submission.css';

const Submission = (props) => (
    <div className="Submission">
        <h3>{props.project}</h3>
        <h4>{props.language}</h4>
        {props.children}
        <input type="button" onClick={props.approveListener} value="Approve remaining and apply" />
        <input type="button" className="redButton" onClick={props.rejectListener} value="Reject all and apply" />
    </div>
);

export default Submission;